import { render, staticRenderFns } from "./addGoodHuozhu.vue?vue&type=template&id=22341f78&scoped=true&"
import script from "./addGoodHuozhu.vue?vue&type=script&lang=js&"
export * from "./addGoodHuozhu.vue?vue&type=script&lang=js&"
import style0 from "./addGoodHuozhu.vue?vue&type=style&index=0&id=22341f78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22341f78",
  null
  
)

export default component.exports